export default {"src":"/_next/static/media/card_bg_brand.dd5d8380.svg","height":435,"width":1031};